var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 2.5L1.6665 5M18.3332 5L15.8332 2.5M4.99984 15.8333L3.33317 17.5M14.9998 15.8333L16.6665 17.5M9.99984 7.5V10.8333L11.6665 12.5M9.99984 17.5C11.7679 17.5 13.4636 16.7976 14.7139 15.5474C15.9641 14.2971 16.6665 12.6014 16.6665 10.8333C16.6665 9.06522 15.9641 7.36953 14.7139 6.11929C13.4636 4.86905 11.7679 4.16667 9.99984 4.16667C8.23173 4.16667 6.53603 4.86905 5.28579 6.11929C4.03555 7.36953 3.33317 9.06522 3.33317 10.8333C3.33317 12.6014 4.03555 14.2971 5.28579 15.5474C6.53603 16.7976 8.23173 17.5 9.99984 17.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.407d86e72978b9ea2d1e2b99ad0e2628.svg";
export { ForwardRef as ReactComponent };